import React, { FC } from 'react';
import ComingSoonSignals from './coming-soon-signals';

const LTVSignals: FC = () => {
	return <ComingSoonSignals signal="ltv" />;
};

export default LTVSignals;
